import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import Icon from 'meinian-package/src/component/icon'
import classNames from 'classnames'
import * as userAuth from 'meinian-package/src/utils/auth'
import TaskDetailModal from 'view/home/inspiration/chooseTaskDrawer/taskDetailModal'
import request from 'meinian-package/src/utils/request'
import Steps, { Step } from 'meinian-package/src/baseComponent/steps'
import ChooseStyleDetail from '../../../../../../component/imageDetail/chooseStyleDetail'
import { hasRelateUrl } from '../../../../../../component/imageDetail/related'
import { formatTime } from '../../../../../../component/util'
import styles from './index.module.less'

export default forwardRef(({ queryParams, currentImage, onBanOperation }:any, ref) => {
  const Length = 3
  const [isFoldDynamic, setIsFoldDynamic] = useState(true)
  const [taskDetailId, setTaskDetailId] = useState(null)
  const [dynamics, setDynamics] = useState([])
  const [insCollList, setInsCollList] = useState([])
  const [isFoldIns, setIsFoldIns] = useState(true)
  const auth = currentImage.loginUserInfo?.inspirationPermissions || []

  useImperativeHandle(ref, () => {
    return {
      onInit
    }
  })

  const onTaskDetail = (missionId) => {
    if (!missionId) {
      return
    }
    setTaskDetailId(missionId)
  }

  const fetchDynamics = async () => {
    try {
      const res:any = await request.get('/zhikuan/mn/dynamic/query-operation-dynamic-info', { params: { targetType: 1, targetId: queryParams.collectId } })
      setDynamics(res)
    } catch (err) {
      console.error(err)
    }
  }

  const fetchInsCollList = async () => {
    try {
      const res:any = await request.get('/ins/inspiration/query-collect-dynamic', { params: { blogId: queryParams.blogId } })
      setInsCollList(res)
    } catch (err) {
      console.error(err)
    }
  }
  const onInit = () => {
    fetchDynamics()
    fetchInsCollList()
  }
  useEffect(() => {
    onInit()
  }, [JSON.stringify(currentImage)])

  const link = (inspirationId, name, parentId) => (parentId && parentId !== -1
    ? `/meinian/home/coll/detail/${inspirationId}?tab=1&inspirationId=${inspirationId}&parentId=${parentId}&name=${name}&trackSourceType=款式详情页`
    : `/meinian/home/coll/detail/${inspirationId}?inspirationId=${inspirationId}&trackSourceType=款式详情页`)

  return <div className={styles.infoViewModule}>
    {
      userAuth.isPermissions(auth, ['F16']) && !!currentImage.isPro && <ChooseStyleDetail
        collectId={queryParams.collectId}
        auth={auth}
        onInitTask={() => fetchDynamics()}
        currentImage={currentImage}
        onBanOperation={onBanOperation}
      />
    }
    <div className={styles.title} style={{ marginTop: '24px' }}>
      款式动态
      {dynamics.length > Length ? <a className={classNames(styles['fold-dynamic'], 'fill-white-bg')} onClick={() => setIsFoldDynamic(pre => !pre)}>{isFoldDynamic ? '展开' : '收起'}<Icon type="m-Vxing_xia" style={{ transform: isFoldDynamic ? undefined : 'rotate(180deg)', transition: 'all 0.3s' }} /></a> : null}
    </div>
    <Steps className={styles.infoViewModuleDynamics}>
      {dynamics?.filter((_, index) => (isFoldDynamic ? index < Length : true)).map((dynamic, i) => <Step
        active={i === 0}
        title={<div
          className={classNames('dynamic-item', i === 0 ? 'active' : '')}
        >
          <div className="dynamic-name">{dynamic.operationType === 114 ? <span>关联<span
            style={{ cursor: 'pointer', color: 'var(--m-link-normal)', marginLeft: '8px' }}
            onClick={() => onTaskDetail(dynamic.missionId)}
          >选款任务</span></span> : dynamic.operationDesc}</div>
          {hasRelateUrl(dynamic) && <a className="dynamic-link link" style={{ color: 'var(--m-link-normal)' }} href={hasRelateUrl(dynamic)} target="_blank" rel="noreferrer">查看详情</a>}
          <div className="meinian-space" />
          <div className="dynamic-user text-overflow">{dynamic.operationName}</div>
          <div className="dynamic-time">{formatTime(dynamic.operationTime)}</div>
        </div>}
      />)}
    </Steps>
    <div className={styles.title} style={{ marginTop: '24px' }}>
      所在灵感集
      {insCollList.length > Length ? <a className={classNames(styles['fold-dynamic'], 'fill-white-bg')} onClick={() => setIsFoldIns(pre => !pre)}>{isFoldIns ? '展开' : '收起'}<Icon type="m-Vxing_xia" style={{ transform: isFoldIns ? undefined : 'rotate(180deg)', transition: 'all 0.3s' }} /></a> : null}
    </div>
    <div className={styles.module}>
      <div>{insCollList?.filter((_, index) => (isFoldIns ? index < Length : true))?.map(ins => <ModuleItem
        label={<a className="ins-name text-overflow" href={link(ins.inspirationId, ins.name, ins?.parentInspirationId)} target="_blank" rel="noreferrer">{ins.inspirationName}</a>}
        value={
          <>
            <span title={ins.name} className="item-name line-1">{ins.name}</span>
            <span className="dynamic-time">{formatTime(ins.collectTime)}</span>
          </>
        }
      />)}
      </div>
    </div>
    {taskDetailId && <TaskDetailModal
      taskItem={{ missionId: taskDetailId }}
      visible={taskDetailId}
      onClose={() => setTaskDetailId(null)}
      auth={undefined}
      //
      tab={undefined}
      onEnd={undefined}
      onEdit={undefined}
      onDelete={undefined}
    />}
  </div>
})

const ModuleItem = (props) => {
  const { label, value } = props
  if (!value) return null
  return <div className="module-item">
    <div className="label">{label}</div>
    <div className="meinian-space" />
    <div className="value">{value}</div>
  </div>
}
